<template>
  <div class="mainbody">
    <div style="height:0.1px"></div>

    <!-- 书籍标题 -->

      <div id="headerdiv">
        <div class="headertitle">{{Data.title_cn}}</div>
      </div>

      <!-- 书籍介绍-->
      <div id="textDiv" v-if="Data.description || Data.parent_guide">
        <div class="maintext" v-html="addDiv(Data.description || Data.parent_guide)"></div>
        <div class="maintext" v-if="Data.cover_picture_link">
        <br>
          <img class="imgCover" id="cover_picture_link" :src="Data.cover_picture_link" title="cover">
        </div>
        <div class="maintext" id="picture_link_div" v-if="Data.picture_link"><a id="picture_link" :href="Data.picture_link">{{ lang.picture_link }}</a></div>
      </div>

      <!-- 推荐理由-->
      <div v-if="Data.recommend_reason">
        <div id="headerdiv">
          <div class="headertitle">{{ lang.recommend_reason }}</div>
        </div>
      <div id="textDiv">
        <div class="maintext" v-html="addDiv(Data.recommend_reason)"></div>
      </div>
    </div>

      <!-- 绘本音频 -->
        <div v-if="Data.media_link">
          <div id="headerdiv">
            <div class="headertitle">{{ lang.book_audio }}</div>
          </div>
          <div class="flex-row-center">
              <audio id="media_link" controls="controls" :src="Data.media_link">
              {{ lang.audio_tips }}
              </audio>
          </div>
        </div>

      <!-- 绘本动画 -->
        <div v-if="Data.video_link">
          <div id="headerdiv">
            <div class="headertitle">{{ lang.book_video }}</div>
          </div>
          <div class="flex-row-center">
            <iframe id="video_link" class="video_iframe" style="z-index:1;"
              :src="Data.video_link" allowfullscreen="" frameborder="0"
              :width="MAXWIDTH"
              :height="MAXHEIGHT"
              ></iframe>
          </div>
        </div>

        <!-- 阅读指导-->
        <div v-if="Data.parent_guide">
          <div id="headerdiv">
            <div class="headertitle">{{ lang.parent_guide_read }}</div>
          </div>
        <div id="textDiv">
          <div class="maintext" v-html="addDiv(Data.parent_guide)"></div>
          <div class="maintext" v-if="Data.parent_aids_link"><strong style="color: orange">{{ lang.parent_aids_link_book }}</strong>:<br><a id="parant_aids_link" :href="Data.parent_aids_link">{{Data.parent_aids_link}}</a></div>
        </div>
      </div>

</div>
</template>

<script>
require('@/assets/css/resource.css')

import BaseVue from '@/components/BaseVue'

export default {
  name: 'BookTemplateNew',
  extends: BaseVue,
  data () {
    return {
      Data: Object()
    }
  },
  created: async function(){
    let data_id = this.$route.params.id
    let url = this.GATEWAY_ORIGINAL + 'bigdata/cej_target/query_book_info?id=' + data_id
    let that = this;
    await this.getLang();
    document.title = this.lang.BookTemplateNewTitle
    this.queryData(url, function (data) {
      that.Data = data
      if (that.Data.video_link){
        that.Data.video_link = that.resetVideoSize(that.Data.video_link)
      }
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/resource/BookNew.vue